import type { CatalogItem } from '@/entities/catalog-item';

import type { Row } from '@tanstack/react-table';

export function isRowRestricted(
  row: Row<CatalogItem>,
  isForwardCurves: boolean,
  isPermissionGranted: boolean
): boolean {
  if (!isPermissionGranted) return true;
  if (isForwardCurves) return false;
  const { Last, Change } = row.original;
  return !Last && !Change;
}
